import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "How far in advance should I book?",
    a: "For local moves, 1–2 weeks is plenty. For long-distance or peak season (May–August), book 3–4 weeks ahead to get your preferred date.",
  },
  {
    q: "Are you a real local business?",
    a: "Yes — family-owned and operated right here in Louisville, KY. We've completed 2,400+ moves across KY, IN, OH and WV since 2019. Real reviews on Google to back it up.",
  },
  {
    q: "Do you charge a deposit?",
    a: "Yes — a $100 deposit holds your date and is applied directly to your final bill. Never an extra charge, just a way to confirm you're committed and we are too.",
  },
  {
    q: "Are there fees for stairs or walk-ups?",
    a: "A flat $20 stair fee applies for properties with significant stair access (3rd floor walk-ups, basements, etc.). No fee for one or two steps at the entry.",
  },
  {
    q: "Do you charge for mileage or fuel?",
    a: "First 10 miles are free. After that it's a flat $2 per mile for the route distance. No separate fuel surcharge — that's it.",
  },
  {
    q: "What forms of payment do you accept?",
    a: "Cash, check, Zelle, and all major credit cards. Card payments include a 3.5% processing fee — cash, check, and Zelle have no surcharge. Payment collected at the end of the move once you're happy.",
  },
  {
    q: "Do you move pianos, gun safes, and antiques?",
    a: "Yes — we have specialty crews and the right gear (piano dollies, four-wheel safes, custom blanket-wrap for antiques). Specialty items quoted separately.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-24 lg:py-32" data-testid="faq-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 grid lg:grid-cols-3 gap-12">
        <div>
          <div className="overline">Questions?</div>
          <h2 className="mt-3 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]">
            Answers.<br />Straight.
          </h2>
          <p className="mt-6 text-[#5C635F] leading-relaxed max-w-md">
            Still curious? Give us a call at <a href="tel:+15025077904" className="text-[#5BB239] font-bold">(502) 507-7904</a> —
            we're real people on real phones, not chatbots.
          </p>
        </div>
        <div className="lg:col-span-2">
          <Accordion type="single" collapsible className="border-t border-[#DDD8C9]">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-b border-[#DDD8C9]">
                <AccordionTrigger className="font-display font-bold text-lg text-left hover:text-[#5BB239] hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#5C635F] leading-relaxed text-base pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
